import React from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody  } from 'reactstrap';
import { withAlert } from 'react-alert'
import { connect } from 'react-redux'

class DeleteDocumentModal extends React.Component {
    constructor(props){
        super(props);

        this.attemptDelete = this.attemptDelete.bind(this) 
    }

    attemptDelete() 
    {
      //Set document to status deleted in archive
      fetch(window.location.protocol + '//' + window.location.host + '/api/archive/documents/'+this.props.file, {
        method: 'DELETE'
      })
      .then(result => 
      {
        this.props.refresh()
        this.props.toggle()
        this.props.alert.success("Deleted destination.");
      })
      .catch(error=>
      {
        //need to log the error
        this.props.alert.error('An error occurred whilst attemping document deletion ' + error);
        
      });
    }

    render() {

        const { localisation } = this.props.userReducer;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>{localisation['delete_document_header'] ? localisation['delete_document_header'].element_lang : 'Delete Document'}</ModalHeader>
                <ModalBody>
                  {localisation['delete_document_confirmation_text'] ? localisation['delete_document_confirmation_text'].element_lang +': ' + this.props.document +'?' : 'Are you sure you want to delete document: ' + this.props.document + '?'}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.attemptDelete}>Delete</Button>
                    <Button id="cancelButton" color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(state => state)(withAlert()(DeleteDocumentModal));